import axios from '../axios';
// 园区列表
export const getSysTissuePage = data => {
  return axios({
    url: '/api/sys/getSysTissuePage',
    method: 'post',
    data
  })
};
// 园区保存
export const saveSysTissue = data => {
  return axios({
    url: '/api/sys/saveSysTissue',
    method: 'post',
    data
  })
};
// 园区修改
export const updateSysTissue = data => {
  return axios({
    url: '/api/sys/updateSysTissue',
    method: 'post',
    data
  })
};
// 园区手机号和名称更新
export const updTissuePhoneAndName = data => {
  return axios({
    url: '/api/sys/updTissuePhoneAndName',
    method: 'post',
    data
  })
};
// 园区状态修改（只更新状态）
export const updateStatusByTissue = data => {
  return axios({
    url: '/api/sys/updateStatusByTissue',
    method: 'post',
    data
  })
};
// 调整组织金额（同时写入充值明细）
export const adjustTissueAmount = data => {
  return axios({
    url: '/api/sys/adjustTissueAmount',
    method: 'post',
    data
  })
};
// 充值历史分页列表
export const getSysTissueAmountPage = data => {
  return axios({
    url: '/api/sys/sys/tissue/amount/getSysTissueAmountPage',
    method: 'post',
    data
  })
};
// 充值历史合计行
export const getSysTissueAmountSum = data => {
  return axios({
    url: '/api/sys/sys/tissue/amount/getSysTissueAmountSum',
    method: 'post',
    data
  })
};
// 查询单条充值明细
export const getSysTissueAmount = data => {
  return axios({
    url: '/api/sys/sys/tissue/amount/getSysTissueAmount',
    method: 'post',
    data
  })
};
// 园区删除
export const deleteSysTissues = data => {
  return axios({
    url: '/api/sys/deleteSysTissues',
    method: 'post',
    data
  })
};
// 园区审核（确认审核）
export const auditSysTissue = data => {
  return axios({
    url: '/api/sys/auditSysTissue',
    method: 'post',
    data
  })
};
// 园区轮播图列表
export const getSysTissueCarouselPage = data => {
  return axios({
    url: '/api/sys/sys/tissue/carousel/getSysTissueCarouselPage',
    method: 'post',
    data
  })
};
// 园区轮播图列表新增
export const saveSysTissueCarousel = data => {
  return axios({
    url: '/api/sys/sys/tissue/carousel/saveSysTissueCarousel',
    method: 'post',
    data
  })
};
// 园区轮播图列表修改
export const updateSysTissueCarousel = data => {
  return axios({
    url: '/api/sys/sys/tissue/carousel/updateSysTissueCarousel',
    method: 'post',
    data
  })
};
// 园区轮播图列表删除
export const deleteSysTissueCarousels = data => {
  return axios({
    url: '/api/sys/sys/tissue/carousel/deleteSysTissueCarousels',
    method: 'post',
    data
  })
};
// 游客信息列表
export const getTVisitorInfoPage = data => {
  return axios({
    url: '/api/sys/t/visitor/info/getTVisitorInfoPage',
    method: 'post',
    data
  })
};
// 园区游客信息分页列表
export const getTParkVisitorInfoPage = data => {
  return axios({
    url: '/api/sys/t/park/visitor/info/getTParkVisitorInfoPage',
    method: 'post',
    data
  })
};
// 游客信息列表保存
export const saveTVisitorInfo = data => {
  return axios({
    url: '/api/sys/t/visitor/info/saveTVisitorInfo',
    method: 'post',
    data
  })
};
// 游客信息列表修改
export const updateTVisitorInfo = data => {
  return axios({
    url: '/api/sys/t/visitor/info/updateTVisitorInfo',
    method: 'post',
    data
  })
};
// 游客信息列表删除
export const deleteTVisitorInfos = data => {
  return axios({
    url: '/api/sys/t/visitor/info/deleteTVisitorInfos',
    method: 'post',
    data
  })
};
// 游客信息导出
export const exportTParkVisitorInfo = data => {
  return axios({
    url: '/api/sys/t/park/visitor/info/exportTParkVisitorInfo',
    method: 'post',
    data
  })
};
// 游玩项目列表
export const getTProjectInfoPage = data => {
  return axios({
    url: '/api/sys/t/project/info/getTProjectInfoPage',
    method: 'post',
    data
  })
};
// 游玩项目列表保存
export const saveTProjectInfo = data => {
  return axios({
    url: '/api/sys/t/project/info/saveTProjectInfo',
    method: 'post',
    data
  })
};
// 游玩项目列表修改
export const updateTProjectInfo = data => {
  return axios({
    url: '/api/sys/t/project/info/updateTProjectInfo',
    method: 'post',
    data
  })
};
// 游玩项目上下架（仅传 id 与 status）
export const listingAndDelistingTProjectInfo = data => {
  return axios({
    url: '/api/sys/t/project/info/listingAndDelisting',
    method: 'post',
    data
  })
};
// 游玩项目列表删除
export const deleteTProjectInfos = data => {
  return axios({
    url: '/api/sys/t/project/info/deleteTProjectInfos',
    method: 'post',
    data
  })
};
// 根据项目 id 获取关联商品（含太阳码 sunCodeImg）
export const getProductByProjectId = data => {
  return axios({
    url: '/api/sys/t/park/product/getProductByProjectId',
    method: 'post',
    data
  })
};
// 游客票券记录表列表
export const getTParkVisitorTicketPage = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/getTParkVisitorTicketPage',
    method: 'post',
    data
  })
};
// 游客票券记录表统计（与分页列表入参一致）
export const getTParkVisitorTicketPageStatistic = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/getTParkVisitorTicketPageStatistic',
    method: 'post',
    data
  })
};
// 游客票券记录详情（按 id）
export const getTParkVisitorTicket = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/getTParkVisitorTicket',
    method: 'post',
    data
  })
};
// 套票核销明细（剩余次数 + 包含项目）
export const getComboTicketInfo = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/getComboTicketInfo',
    method: 'post',
    data
  })
};
// 票券核销明细分页
export const getTParkVisitorTicketDetailPage = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/getTParkVisitorTicketDetailPage',
    method: 'post',
    data
  })
};
// 游客票券记录表列表保存
export const saveTParkVisitorTicket = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/saveTParkVisitorTicket',
    method: 'post',
    data
  })
};
// 游客票券记录表列表修改
export const updateTParkVisitorTicket = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/updateTParkVisitorTicket',
    method: 'post',
    data
  })
};
// 游客票券记录表列表删除
export const deleteTParkVisitorTickets = data => {
  return axios({
    url: '/api/sys/t/park/visitor/ticket/deleteTParkVisitorTickets',
    method: 'post',
    data
  })
};
// 游客储值卡表列表
export const getTParkVisitorPrepaidPage = data => {
  return axios({
    url: '/api/sys/t/park/visitor/prepaid/getTParkVisitorPrepaidPage',
    method: 'post',
    data
  })
};
// 根据卡号查询储值卡余额
export const getAmountByCardNo = data => {
  return axios({
    url: '/api/sys/t/park/visitor/prepaid/getAmountByCardNo',
    method: 'post',
    data
  })
};
// 园区产品列表
export const getTParkProductPage = data => {
  return axios({
    url: '/api/sys/t/park/product/getTParkProductPage',
    method: 'post',
    data
  })
};
// 园区单个产品详情
export const getTParkProduct = data => {
  return axios({
    url: '/api/sys/t/park/product/getTParkProduct',
    method: 'post',
    data
  })
};
// 园区产品保存
export const saveTParkProduct = data => {
  return axios({
    url: '/api/sys/t/park/product/saveTParkProduct',
    method: 'post',
    data
  })
};
// 园区产品修改
export const updateTParkProduct = data => {
  return axios({
    url: '/api/sys/t/park/product/updateTParkProduct',
    method: 'post',
    data
  })
};
// 园区产品上下架（仅传 id 与 status）
export const takeOffTheShelves = data => {
  return axios({
    url: '/api/sys/t/park/product/takeOffTheShelves',
    method: 'post',
    data
  })
};
// 园区产品删除
export const deleteTParkProducts = data => {
  return axios({
    url: '/api/sys/t/park/product/deleteTParkProducts',
    method: 'post',
    data
  })
};

// 园区商品-项目关联列表（按商品id）
export const getTParkProductProjectLinkList = data => {
  return axios({
    url: '/api/sys/t/park/product/project/getTParkProductProjectLinkList',
    method: 'post',
    data
  })
};

// 园区产品-重新生成商品二维码/日销码（sunCodeImg）
export const regenTParkProductSunCode = data => {
  return axios({
    url: '/api/sys/t/park/product/regenTParkProductSunCode',
    method: 'post',
    data
  })
};

// 园区设备分页
export const getTParkDevicePage = data => {
  return axios({
    url: '/api/sys/t/park/device/getTParkDevicePage',
    method: 'post',
    data
  })
};
// 园区设备详情
export const getTParkDevice = data => {
  return axios({
    url: '/api/sys/t/park/device/getTParkDevice',
    method: 'post',
    data
  })
};
// 园区设备保存
export const saveTParkDevice = data => {
  return axios({
    url: '/api/sys/t/park/device/saveTParkDevice',
    method: 'post',
    data
  })
};
// 园区设备修改
export const updateTParkDevice = data => {
  return axios({
    url: '/api/sys/t/park/device/updateTParkDevice',
    method: 'post',
    data
  })
};
// 园区设备删除
export const deleteTParkDevices = data => {
  return axios({
    url: '/api/sys/t/park/device/deleteTParkDevices',
    method: 'post',
    data
  })
};
// 园区设备激活
export const activateTParkDevice = data => {
  return axios({
    url: '/api/sys/t/park/device/activate',
    method: 'post',
    data
  })
};

// 园区设备-关联项目分页列表
export const getTDeviceProjectLinkPage = data => {
  return axios({
    url: '/api/sys/t/device/project/link/getTDeviceProjectLinkPage',
    method: 'post',
    data
  })
};

// 园区订单主表（游客下单）
// 分页列表
export const getTParkVisitorOrderPage = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/getTParkVisitorOrderPage',
    method: 'post',
    data
  })
};
// 园区订单主表统计（与分页列表入参一致）
export const getTParkVisitorOrderPageStatistic = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/getTParkVisitorOrderPageStatistic',
    method: 'post',
    data
  })
};
// 详情（按 id）
export const getTParkVisitorOrder = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/getTParkVisitorOrder',
    method: 'post',
    data
  })
};
// 商品订单关联分页（按订单id查询明细）
export const getTProductOrderLinkPage = data => {
  return axios({
    url: '/api/sys/t/product/order/link/getTProductOrderLinkPage',
    method: 'post',
    data
  })
};
// 按订单号查询子单（含套票 tProductOrderLinks，用于详情补全）
export const getOrderChildrenByOrderIds = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/getOrderChildrenByOrderIds',
    method: 'post',
    data
  })
};
// 园区订单支付核销分页
export const getTParkVisitorOrderPaymentPage = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/payment/getTParkVisitorOrderPaymentPage',
    method: 'post',
    data
  })
};
// 新增/下单
export const saveTParkVisitorOrder = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/saveTParkVisitorOrder',
    method: 'post',
    data
  })
};
// 修改
export const updateTParkVisitorOrder = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/updateTParkVisitorOrder',
    method: 'post',
    data
  })
};
// 删除（批量）
export const deleteTParkVisitorOrders = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/deleteTParkVisitorOrders',
    method: 'post',
    data
  })
};
// 订单支付
export const orderPay = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/orderPay',
    method: 'post',
    data
  })
};

// 查询订单支付轮询状态（按订单id）
export const getPaymentPollingStatusById = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/payment/getPaymentPollingStatusById',
    method: 'post',
    data
  })
};

// 关闭订单（关支付渠道 + 取消业务）
export const closeOrderStatus = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/payment/closeOrderStatus',
    method: 'post',
    data
  })
};

// 订单金额重新计算（按支付方式等规则）
export const calculateOrderAmount = data => {
  return axios({
    url: '/api/sys/t/park/visitor/order/calculateOrderAmount',
    method: 'post',
    data
  })
};

// 园区游客余额（按 visitorId 获取）
export const getBalanceByVisitorId = data => {
  return axios({
    url: '/api/sys/t/park/visitor/balance/getBalanceByVisitorId',
    method: 'post',
    data
  })
};

// 园区游客余额+会员信息（按 visitorId 获取）
export const getBalanceAndVisitorByVisitorId = data => {
  return axios({
    url: '/api/sys/t/park/visitor/balance/getBalanceAndVisitorByVisitorId',
    method: 'post',
    data
  })
};

// 微信小程序配置（MinProgram）
export const getSysWxMinProgramConfigPage = data => {
  return axios({
    url: '/api/sys/sys/wx/min/program/getSysWxMinProgramConfigPage',
    method: 'post',
    data
  })
};

export const getSysWxMinProgramConfig = data => {
  return axios({
    url: '/api/sys/sys/wx/min/program/getSysWxMinProgramConfig',
    method: 'post',
    data
  })
};

export const saveSysWxMinProgramConfig = data => {
  return axios({
    url: '/api/sys/sys/wx/min/program/saveSysWxMinProgramConfig',
    method: 'post',
    data
  })
};

export const updateSysWxMinProgramConfig = data => {
  return axios({
    url: '/api/sys/sys/wx/min/program/updateSysWxMinProgramConfig',
    method: 'post',
    data
  })
};

// 重新生成园区首页太阳码
export const generateTissueHomeSunCode = data => {
  return axios({
    url: '/api/sys/generateTissueHomeSunCode',
    method: 'post',
    data
  })
};

// 查询当前登录园区卡押金
export const getCurrentTissueDeposit = data => {
  return axios({
    url: '/api/sys/getCurrentTissueDeposit',
    method: 'post',
    data
  })
};

// 修改当前登录园区卡押金
export const updateCurrentTissueDeposit = data => {
  return axios({
    url: '/api/sys/updateCurrentTissueDeposit',
    method: 'post',
    data
  })
};

// 查询当前登录园区是否园中园
export const getCurrentTissueParkInPark = data => {
  return axios({
    url: '/api/sys/getCurrentTissueParkInPark',
    method: 'post',
    data
  })
};

// 修改当前登录园区是否园中园
export const updateCurrentTissueParkInPark = data => {
  return axios({
    url: '/api/sys/updateCurrentTissueParkInPark',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/basis.js